import { createModule } from "saga-slice";
import { call, delay, put } from "redux-saga/effects";
import stockService from "../services/stockService";
const initialState = {
    stocks: [],
    movements: [],
    reconciliation: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
};

const stockSlice = createModule({
    name: 'stock',
    initialState,
    reducers: {
        addStock: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        updateStock: (state) => {
            state.loading = true;
        },
        transferStock: (state) => {
            state.loading = true;
        },
        reconcileStocks: (state) => { state.loading = true; },
        uploadStocks: (state, action) => {
            state.loading = true;
        },

        deleteStock: (state, action) => {
            state.loading = true;
        },
        adjustStock: (state) => {
            state.loading = true;
        },
        listStocks: (state) => {
            state.loading = true;
        },
        getMouvements: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.stocks = payload;
        },
        fetchedMovements: (state, payload) => {
            state.loading = false;
            state.movements = payload;
        },
        fetchedReconciliation: (state, payload) => {
            state.loading = false;
            state.reconciliation = payload;
        },

        finishFetching: (state) => {
            state.isFetching = false;
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(stockService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload?.onSuccess) yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) yield call(payload.onError, e);
            }
        },
        *[A.listStocks]({ payload }) {
            try {
                const { data } = yield call(stockService.listStocks, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload?.onSuccess) yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) yield call(payload.onError, e);
            }
        },
        *[A.uploadStocks]({ payload }) {
            try {
                const { data } = yield call(stockService.upload, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
        *[A.transferStock]({ payload }) {
           try {
                yield call(stockService.transfer, payload.data);
                yield put(A.finishFetching());
                if (payload.onSuccess) yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
        *[A.adjustStock]({ payload }) {
            try {
                const { data } = yield call(stockService.adjustStock, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },

        *[A.updateStock]({ payload }) {
            try {
                const { data } = yield call(stockService.update, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
        *[A.deleteStock]({ payload }) {
            try {
                const { data } = yield call(stockService.delete, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.getMouvements]({ payload }) {
            try {
                const { data } = yield call(stockService.getMouvements, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedMovements(data));
                if (payload?.onSuccess) yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError(e?.response?.data || "Erreur lors du chargement des mouvements"));
                if (payload?.onError) yield call(payload.onError, e);
            }
        },
        *[A.reconcileStocks]({ payload }) {
            try {
                const { data: started } = yield call(stockService.startReconciliation, payload?.entrepotId || null);
                yield put(A.finishFetching());
                if (payload?.onStarted) yield call(payload.onStarted, started);
                let job = started;
                while (["QUEUED", "RUNNING", "CANCEL_REQUESTED"].includes(job.status)) {
                    yield delay(3000);
                    const response = yield call(stockService.getBackgroundJob, job.id);
                    job = response.data;
                }
                if (job.status !== "COMPLETED") throw new Error(job.errorSummary || "Diagnostic interrompu");
                const jobId = String(job.id).replace("JOB:", "");
                const { data } = yield call(stockService.reconciliationResult, jobId);
                yield put(A.fetchedReconciliation(data));
                if (payload?.onSuccess) yield call(payload.onSuccess);
            } catch (e) {
                yield put(A.fetchError(e?.response?.data || "Erreur lors du diagnostic de stock"));
                if (payload?.onError) yield call(payload.onError, e);
            }
        }
    }),

});

export default stockSlice;
export const stockActions = stockSlice.actions;

